<div class="mb-5">
  <label class="form-label">
    {{ label | translate }}
  </label>
  <!-- <input type="text" bsDatepicker class="form-control form-control-lg form-control-solid" [class.is-invalid]="isControlInvalid()"
    [class.is-valid]="isControlValid()" [formControl]="control" [bsConfig]="datePickerConfig"
    [attr.name]="controlName" [attr.placeholder]="placeholder | translate" autocomplete="off" /> -->


  <div class="valid-feedback" *ngIf="isControlValid()">
    {{ label | translate }} {{ 'MENU.Correct' | translate }}
  </div>
  <div class="invalid-feedback" *ngIf="controlHasError('required')">
    {{ label | translate }} {{ 'MENU.IsRequired' | translate }}
  </div>
</div>